// App.js
import React from 'react';
import './css/App.css';
import './css/Navbar.css';
import './css/PortfolioGrid.css';
import './css/RunningLog.css';

import { HashRouter as Router, Routes, Route } from 'react-router-dom'; 
import Navbar from './Navbar';
import PortfolioGrid from './PortfolioGrid';

import About from './pages/About';
import Blog from './Blog';
import AI from './pages/AI';
import TheraText from './pages/TheraText';
// import CyberClub from './pages/CyberClub';
// import More from './pages/More';
// import RunningLog from './pages/RunningLog';
// import LearningLog from './pages/LearningLog';
import Funding from './pages/Funding';
import Post1 from './pages/Posts/LearningPost1-RAG';
import Post2 from './pages/Posts/LearningPost2';
import Post3 from './pages/Posts/LearningPost3';
import Post4 from './pages/Posts/LearningPost4';
import Post6 from './pages/Posts/LearningPost6';
import Post7 from './pages/Posts/LearningPost7';
import Post9 from './pages/Posts/LearningPost9';
import StoryOne from './pages/Posts/StoryOne';
import StoryTwo from './pages/Posts/StoryTwo';
import StoryThree from './pages/Posts/StoryThree';
import StoryFour from './pages/Posts/StoryFour';
import StorySix from './pages/Posts/StorySix';
import SignUp from './pages/SignUp';
import Gifts from './pages/Gifts';
import CreateGift from './pages/CreateGift';
import Coins from './pages/eBay';
import NewsPage1 from './pages/News';
import ThemedNews1 from './pages/Posts/ThemedNews1';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="main-container">
          <Navbar />
          <Routes>
            <Route path="/" element={<SignUp />} />
            <Route path="/home" element={<PortfolioGrid />} />
            <Route path="/newsinawink" element={<NewsPage1 />} />
            <Route path="/about" element={<About />} />
            <Route path="/coins" element={<Coins />} />
            <Route path="/ai" element={<AI />} />
            <Route path="/theratext" element={<TheraText />} />
            <Route path="/blog" element={<Blog />} />
            {/* <Route path="/cyberclub" element={<CyberClub />} /> */}
            {/* <Route path="/more" element={<More />} />
            <Route path="/running-log" element={<RunningLog />} />
            <Route path="/learninglog" element={<LearningLog />} /> */}
            <Route path="/post1" element={<Post1 />} />
            <Route path="/post2" element={<Post2 />} />
            <Route path="/post3" element={<Post3 />} />
            <Route path="/post4" element={<Post4 />} />
            <Route path="/post6" element={<Post6 />} />
            <Route path="/post7" element={<Post7 />} />
            <Route path="/post9" element={<Post9 />} />
            <Route path="/story/1" element={<StoryOne />} />
            <Route path="/story/2" element={<StoryTwo />} />
            <Route path="/story/3" element={<StoryThree />} />
            <Route path="/story/4" element={<StoryFour />} />
            <Route path="/story/6" element={<StorySix />} />
            <Route path="/theme-world-cup" element={<ThemedNews1 />} />
            <Route path="/funding" element={<Funding />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/giftcycle" element={<Gifts />} />
            <Route path="/news-signup" element={<CreateGift />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
